var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.hasLoaded)?_c('span',{staticClass:"fa fa-spin fa-spinner fa-fw"}):_c('span',[_vm._v(_vm._s(_vm.mails))])])}
var staticRenderFns = []

export { render, staticRenderFns }